import { z } from 'zod';

export type TrelloConfig = {
  syncMap?: Record<string, string>;
  cards?: Record<string, string>;
};

export const agencySchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  contactEmail: z.string().email().nullable().optional(),
  aiInstructions: z.string().nullable().optional(),
  aiAgentName: z.string().nullable().optional(),
  trelloConfig: z.custom<TrelloConfig>().nullable().optional(),
  trelloToken: z.string().nullable().optional(),
  holidayCountries: z.array(z.string()).default([]),
  status: z.enum(['pending', 'accepted', 'rejected', 'deleted']).optional(),
  role: z.enum(['admin', 'member', 'client', 'system']).optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AgencySchema = z.infer<typeof agencySchema>;
